'use client'
import { GeneralInformation } from '@/payload-types'
import { useHeaderTheme } from '@onclicks/providers/HeaderTheme'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { HeaderDesktop } from './HeaderDesktop/HeaderDesktop'
import { MobileNav } from './HeaderMobile/MobileNav'
import { cn } from '@onclicks/utilities/ui'

export const HeaderClient: React.FC<GeneralInformation> = (props) => {
  /* Storing the value in a useState to avoid hydration errors */
  const [theme, setTheme] = useState<string | null>(null)
  const { headerTheme, setHeaderTheme } = useHeaderTheme()
  const pathname = usePathname()

  useEffect(() => {
    setHeaderTheme(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    if (headerTheme && headerTheme !== theme) setTheme(headerTheme)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTheme])

  return (
    <header className={cn('relative z-999')}>
      <HeaderDesktop data={props} />
      <MobileNav data={props} />
    </header>
  )
}
